// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1515":"95ce269c","5669":"95ce269c","6662":"95ce269c","6912":"8bbb3235"}[chunkId] + ".chunk.css";
};